import React from "react";
import {
  FaHome,
  FaUser,
  FaBriefcase,
  FaAddressBook,
 
} from "react-icons/fa";
import "./content.css";

function Content() {
  return (
    <div>
      {/* navbar section starts */}
      <div>
        <nav className="navbar cursorPointer">
          <a>
            {" "}
            <i>
              {" "}
              <FaHome />{" "}
            </i>{" "}
            <span> Home </span>{" "}
          </a>
          <a>
            {" "}
            <i>
              {" "}
              <FaUser />{" "}
            </i>{" "}
            <span> About </span>{" "}
          </a>
          <a>
            {" "}
            <i>
              {" "}
              <FaBriefcase />{" "}
            </i>{" "}
            <span> Portfolio </span>{" "}
          </a>
          <a>
            {" "}
            <i>
              {" "}
              <FaAddressBook />{" "}
            </i>{" "}
            <span> Contact </span>{" "}
          </a>
        </nav>
      </div>
      {/* navbar section ends */}

    </div>
  );
}

export default Content;
